import script from "./CompanyList.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyList.vue?vue&type=script&setup=true&lang=js"

import "./CompanyList.vue?vue&type=style&index=0&id=803e8ad8&lang=css"

const __exports__ = script;

export default __exports__